<template>
  <side-view class="extra-staff">
    <template #left>
      <div class="app-control">
        <p class="app-title">员工标签</p>
        <!-- <div class="right-region">
          <i class="el-icon-plus" @click="openTreeDialog()"></i>
        </div> -->
      </div>
      <el-tree
        :data="tree.datas"
        :props="tree.props"
        :node-key="tree.nodeKey"
        show-checkbox
        @check="initDatas"
        @node-click="checkData"
        v-loading="tree.loading"
        ref="tree"
      >
      <div class="app-control" slot-scope="{data}">
        <span>{{data[tree.props.label]}}</span>
        <!-- <div class="right-region">
          <i class="el-icon-setting" @click.stop="openTreeDialog(data[tree.nodeKey], data[tree.props.label])"></i>
          <i class="el-icon-delete" @click.stop="delTreeNode(data[tree.nodeKey])"></i>
        </div> -->
      </div>
      </el-tree>
    </template>
    <template #right>
      <div class="app-panel blank-v blank-h">
        <p class="app-title">外部员工</p>
        <div class="app-control app-table-control">
          <div class="right-region">
            <el-input placeholder="请输入姓名或电话" v-model="search.value" clearable></el-input>
            <el-button type="primary" @click="searchParams">搜索</el-button>
            <el-button @click="resetParams">重置</el-button>
          </div>
        </div>
        <el-table :data="datas" v-loading="loading">
          <el-table-column label="照片">
            <template slot-scope="{row}">
              <el-image :src="row.face_data[0].attachment_data.attachment_access_url" :preview-src-list="[row.face_data[0].attachment_data.attachment_access_url]"></el-image>
            </template>
          </el-table-column>
          <el-table-column label="姓名" prop="project_external_staff_attr.external_staff_name"></el-table-column>
          <el-table-column label="近期抓拍时间" prop="last_recognition_at"></el-table-column>
          <el-table-column label="到访次数" prop="attr_data.project_customer_day_visit_count"></el-table-column>
          <el-table-column label="操作">
            <template slot-scope="{row}">
              <el-button type="text" @click="scan(row.attr_data.project_customer_id)">查看</el-button>
              <el-button type="text" @click="edit(row.project_external_staff_attr.project_external_staff_attr_id)">编辑</el-button>
              <el-button type="text" @click="mark(row.attr_data.project_customer_id)">标记</el-button>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination :total="page.total" :page-size="page.pageSize" :current-page="page.currentPage" @current-change="currentChange" background></el-pagination>
      </div>
    </template>
    <el-dialog :title="tree.dialog.title" :visible.sync="tree.dialog.show" center :width="dialogWidth" append-to-body>
      <template v-if="tree.dialog.show">
        <el-form ref="form" :model="tree.dialog.form" :rules="tree.dialog.rules" label-position="top">
          <el-form-item label="名称" prop="name">
            <el-input v-model="tree.dialog.form.name" placeholder="请输入名称"></el-input>
          </el-form-item>
        </el-form>
        <div slot="footer">
          <el-button type="primary" @click="treeDialogSubmit">确定</el-button>
          <el-button @click="tree.dialog.show = false">取消</el-button>
        </div>
      </template>
    </el-dialog>
    <el-drawer :title="infoDialog.title" :visible.sync="infoDialog.show" center size="80%" append-to-body>
      <customer-information :id="infoDialog.id" v-if="infoDialog.show"></customer-information>
    </el-drawer>
  </side-view>
</template>

<script>
  import ConfirmStaffService from '@/io/confirm_staff.js';
  import ExtraStaffService from '@/io/extra_staff.js';
  import SideView from '@/components/SideView.vue';
  import CustomerInformation from '@/views/CustomerInformation.vue';

  export default {
    name: 'ExtraStaff',
    data() {
      return {
        tree: {
          loading: false,
          datas: [],
          nodeKey: 'project_external_staff_tag_id',
          props: {
            label: 'external_staff_tag_name',
            children: 'children'
          },
          dialog: {
            show: false,
            title: null,
            id: null,
            form: {
              name: null
            },
            rules: {
              name: [
                {
                  required: true, message: '请输入标签名称'
                }
              ]
            }
          }
        },
        infoDialog: {
          title: '员工详情',
          show: false,
          id: null
        },
        search: {
          value: ''
        },
        loading: false,
        datas: [],
        page: {
          pageSize: 0,
          total: 0,
          currentPage: 1
        },
      }
    },
    mounted () {
      this.initTree();
    },
    watch: {
      'tree.datas'(newValue, oldValue) {
        this.$nextTick(() => {
          this.initDatas();
        });
      }
    },
    components: {
      SideView,
      CustomerInformation
    },
    methods: {
      checkData(data, node) {
        this.$refs.tree.setChecked(node, !node.checked);
        this.initDatas();
      },
      scan(id) {
        this.infoDialog.show = true;
        this.infoDialog.id = id;
      },
      edit(id) {
        this.$router.push({
          path: `/extra_staff/edit/${id}`
        });
      },
      mark(id) {
        this.$confirm(
          '确认标记为项目客户?',
          '提示',
          {
            type: 'warning'
          }
        ).then(() => {
          return ConfirmStaffService.mark(id, 1);
        }).then(res => {
          return this.initDatas();
        }).then(res => {
          this.$message.success('标记成功');
        }).catch(() => {});
      },
      searchParams() {
        this.page.currentPage = 1;
        this.initDatas();
      },
      resetParams() {
        this.search.value = '';
        this.searchParams();
      },
      initDatas() {
        ExtraStaffService.listPage(this.$refs.tree.getCheckedKeys(), this.search.value, this.page.currentPage).then(res => {
          this.datas = res.data.data;
          this.page.pageSize = res.data.per_page;
          this.page.total = res.data.total;
        }).catch(() => {});
      },
      currentChange(page) {
        this.page.currentPage = page;
        this.initDatas();
      },
      initTree() {
        this.tree.loading = true;
        return ExtraStaffService.tagList().then(res => {
          this.tree.datas = res.data.project_external_staff_tag_list;
        }).catch(() => {}).finally(() => {
          this.tree.loading = false;
        });
      },
      openTreeDialog(id, name) {
        this.tree.dialog.title = id ? '编辑标签' : '添加标签';
        this.tree.dialog.show = true;
        this.tree.dialog.id = id;
        this.tree.dialog.form.name = name;
      },
      delTreeNode(id) {
        this.$confirm(
          '确认删除?',
          '提示',
          {
            type: 'warning'
          }
        ).then(() => {
          return ExtraStaffService.delTag(id);
        }).then(res => {
          return this.initTree();
        }).then(res => {
          this.$message.success('删除成功');
        }).catch(() => {});
      },
      treeDialogSubmit() {
        this.$refs.form.validate(valid => {
          if (valid) {
            if (this.tree.dialog.id) {
              ExtraStaffService.editTag(this.tree.dialog.id, this.tree.dialog.form.name).then(() => {
                this.$message.success('编辑成功');
                this.tree.dialog.show = false;
                this.initTree();
              }).catch(() => {});
            } else {
              ExtraStaffService.addTag(this.tree.dialog.form.name).then(() => {
                this.$message.success('创建成功');
                this.tree.dialog.show = false;
                this.initTree();
              }).catch(() => {});
            }
          }
        });
      }
    },
  }
</script>

<style lang="less" scoped>
  @import '../assets/styles/tools.less';
  .extra-staff {
    /deep/ .left-region {
      padding: 20px;
      & > .app-control {
        margin-bottom: 18px;
        .right-region {
          i {
            font-size: 18px;
            color: @color-primary;
            cursor: pointer;
          }
        }
      }
      .el-tree {
        .el-tree-node {
          &:focus {
            & > .el-tree-node__content {
              background-color: initial;
            }
          }
          .el-tree-node__content {
            &:hover {
              background-color: initial;
              color: @color-primary;
              & > .app-control {
                .right-region {
                  i {
                    display: block;
                  }
                }
              }
            }
            .el-tree-node__expand-icon {
              font-size: 0;
              padding: 0;
            }
            & > .app-control {
              width: 100%;
              .right-region {
                i {
                  display: none;
                  color: @color-primary;
                  font-size: 16px;
                }
              }
            }
          }
        }
      }
    }
  }
</style>